import _ from 'lodash';
import EventMg, { EventType } from '../utilities/EventManager';

class splitViewManager {
  constructor() {
    this.split = [true, false];
    this.prevSplit = [true, false];
    this.conference = false;
    this.delegate = [];
    this.forceDelegate = [];

    EventMg.addEventListener(EventType.CONFERENCE_MODE, b => {
      this.conferenceMode(b);
      this.publish();
    });
  }

  /**
   * 登録
   * @param {function} func
   */
  setDelegate(func) {
    this.delegate.push(func);
  }
  setForceDelegate(func) {
    this.forceDelegate.push(func);
  }

  /**
   * デリゲート
   */
  publish() {
    _.each(this.delegate, func => {
      if (func) {
        func(this.split, this.conference);
      }
    });
  }

  /**
   * 1画面化
   * @param {int} index viewの番号
   * @param {boolean} status viewの状態
   */
  singleViewUpdate(index, status) {
    this.conference = false;
    this.split = [false, false];
    this.split[index - 1] = status;
    this.publish();
  }

  /**
   *
   * 強制画面
   * @param {int} index viewの番号
   * @param {boolean} status viewの状態
   */
  forceSingleViewUpdate() {
    _.each(this.forceDelegate, func => {
      func();
    });
  }

  /**
   * 2画面化
   */
  multiViewUpdate() {
    this.split = [true, true];
    this.conference = false;
    this.publish();
  }

  /**
   * 会議モード
   */
  conferenceMode(b) {
    // console.log('分割画面 splitViewManager 1 ', b, this.split, this.prevSplit);
    if (b) {
      this.prevSplit = _.clone(this.split);
      this.split = [true, false];
    } else {
      this.split = this.prevSplit;
    }

    //this.split = !b?[true,false]:[true,false];
    this.conference = b;
    // console.log('分割画面 splitViewManager 2 ', b, this.split, this.prevSplit);
    this.publish();
  }

  /**
   * viewの開閉状態
   */
  getViewStatus() {
    return this.split;
  }

  /* eslint-disable no-unused-vars */

  /**
   *
   * @param {int} index
   * @param {string} url
   */
  load(index, url) {}

  getParam() {
    const url = window.location.href.split('/');
    const url1 = _.lastIndexOf(url, 2);
    const url2 = _.lastIndexOf(url, 1);
  }
  /* eslint-enable no-unused-vars */
}
const _splitViewManager = new splitViewManager();
export default _splitViewManager;



// WEBPACK FOOTER //
// ./src/utilities/splitViewManager.js